export enum FilterNumberRangeTypeEnum {
    UNKNOWN = 0,
    ALL,
    RANGE,
}
